import { useEffect, useState } from 'react';

import useCustomSelector from '../../../redux/hooks/useCustomSelector';
import useActionCreator from '../../../redux/hooks/useActionCreator';

import { GroupState } from "@reducers/types/inventory/group-state";

interface UseGroupList {
    settingsGroupState: GroupState;
    handleQuery: (key: string, value: number | string) => void;
}

export const useGroupList = (): UseGroupList => {
    const { groupFetchActionHandler } = useActionCreator();

    const [query, setQuery] = useState({
        page: 1,
        size: 10,
        search: '',
    });

    const handleQuery = (key: string, value: number | string) =>
        setQuery((prev) => ({
            ...prev,
            [key]: value,
        }));

    const settingsGroupState = useCustomSelector(
        (store) => store.inventory.settingsGroupState,
    );

    useEffect(() => {
        groupFetchActionHandler(query);
    }, [query]);

    return {
        handleQuery,
        settingsGroupState,
    };
};
